import styles from "./ResourceTile.module.css";
import { useMemo } from "react";

function ResourceTile({ name, href }) {
    const extension = useMemo(
        () => "." + href.split(".").at(-1).toUpperCase(),
        [href]
    );

    function handleClick() {
        window.gtag("event", "page_view", {
            page_path: window.location.pathname,
            page_title: name,
        });
    }

    return (
        <a
            href={href}
            onClick={handleClick}
            target="_blank"
            rel="noreferrer"
            className={styles.tile}
        >
            <div className={styles.icon_container}>
                <img
                    src="/images/document-icon.svg"
                    alt="document icon"
                    draggable={false}
                />
                <div className={styles.extension}>{extension}</div>
            </div>
            <div className={styles.text}>
                <div className={styles.name}>{name}</div>
                <div className={styles.message}>Click to download document</div>
            </div>
        </a>
    );
}

export default ResourceTile;
